import { Injectable } from '@angular/core';
import { NavigationService } from '@shared-services/navigation.service';
import { NavigationDataManager } from '@shared-managers/navigation-data.manager';

@Injectable({
	providedIn: 'root',
})
export class BeegoController {
	constructor(
		private readonly navigationService: NavigationService,
		private readonly navigationDataManager: NavigationDataManager
	) {
		this.navigationService.onNavigateToCurrentPage().subscribe(() => {
			//
		});
	}
}
